import { render, staticRenderFns } from "./NewspaperPdfViewSidebar.vue?vue&type=template&id=3355c42d&scoped=true&"
import script from "./NewspaperPdfViewSidebar.vue?vue&type=script&lang=js&"
export * from "./NewspaperPdfViewSidebar.vue?vue&type=script&lang=js&"
import style0 from "./NewspaperPdfViewSidebar.vue?vue&type=style&index=0&id=3355c42d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3355c42d",
  null
  
)

export default component.exports